var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "0,16 0,0 16,8",
    fill: "currentColor",
    transform: "matrix(0.90816035,0,0,0.90816035,0.45408022,0.7347172)"
  })));
};
export default SvgPlay;